import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, firstValueFrom, of, Subscription } from 'rxjs';
import { catchError, first, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { EmailEntity } from '../dave-data-module/entities/email.entity';
import { FileDataService } from '../dave-data-module/services/file-data.service';
import { HttpService } from '../dave-data-module/services/http.service';
import { State } from '../dave-data-module/State';
import { BaseActionTypes } from '../dave-data-module/State/actions/base.actions';
import { getToken } from '../dave-data-module/State/selectors/base.selectors';
import { blobToBase64 } from '../helper/helper';

@Injectable({
    providedIn: 'root',
})
export class MailContentService implements OnDestroy {
    private subscriptions: Subscription[] = [];
    private token = '';

    constructor(private gatewayHttpService: HttpService, private store: Store<State>, private fileDataService: FileDataService, private Api: HttpService) {
        this.subscriptions.push(this.store.select(getToken).subscribe((t) => (this.token = t)));
    }

    public getEmailBody(id: number) {
        let queryString = `
                                query{
                                  email(id: ${id}){
                                    hTMLBody
                                    textBody
                                  }
                                }`;
        return this.gatewayHttpService.graphQl({ query: queryString }, { token: this.token }).pipe(
            first(),
            map(res => {
                if (res?.email?.length === 1){
                    return {
                        html: res.email[0].hTMLBody,
                        text: res.email[0].textBody,
                    };
                } else {
                    throw 'email wrong response, emailId: ' + id;
                }
            }),
            catchError((err, caught) => {
                this.store.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'Email Inhalt abrufen fehlgeschlagen',
                            Err: err,
                            Caught: caught,
                        },
                    }),
                );
                return of(null);
            }),
        )
    }
    public async replaceInlineCidImages(html: string, fileIds: number[], replaceInlineImagesCid: 'file_service_url' | 'base64' = 'file_service_url') {
        const files = await firstValueFrom(this.fileDataService.GetFilesById(fileIds, { withEmailInline: true }));
        const token = await firstValueFrom(this.store.select(getToken));

        if (replaceInlineImagesCid === 'file_service_url') {
            let body = html;
            files.forEach((f) => {
                let cid = f.MetaData?.email?.cid;
                if (cid) {
                    let url = this.Api.GetUrl(f.GetLastVersion().GetDownloadLink(token), 'file');
                    // @ts-ignore
                    body = body.replaceAll('cid:' + cid, url);
                }
            });
            return body;
        } else if (replaceInlineImagesCid === 'base64') {
            const base64files = await Promise.all(files.map((file) =>
                firstValueFrom(this.Api.download(file.GetLastVersion()).pipe(
                    switchMap(blobToBase64),
                    map((base64) => ({ fileEntity: file, base64 })),
                ))
            ))

            let body = html;
            base64files.forEach((f) => {
                let cid = f.fileEntity.MetaData?.email?.cid;
                if (cid && f.base64) {
                    // @ts-ignore
                    body = body.replaceAll('cid:' + cid, f.base64);
                }
            });
            return body;
        }
    }
    public TransformToMail(e: EmailEntity, replaceInlineImagesCid: false | 'file_service_url' | 'base64' = false) {
        return this.getEmailBody(e.Id).pipe(
            switchMap((res) => {
                if (replaceInlineImagesCid && e.DocumentIds?.length) {
                    if (res?.html != null) {
                        if (replaceInlineImagesCid === 'file_service_url' || replaceInlineImagesCid === 'base64') {
                            return this.replaceInlineCidImages(res.html, e.DocumentIds, replaceInlineImagesCid).then((html) =>
                                ({
                                    html,
                                    Text: res.text,
                                })
                            );
                        }
                    } else {
                        return of({
                            html: res?.html || '',
                            Text: res?.text || '',
                        });
                    }
                } else {
                    return of({
                        html: res?.html || '',
                        Text: res?.text || '',
                    });
                }
            }),
            catchError((err, caught) => {
                this.store.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: 'Email Inhalt abrufen gehlgeschlagen',
                            Err: err,
                            Caught: caught,
                        },
                    }),
                );
                return of({
                    html: '',
                    Text: '',
                });
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
